import React from 'react';
import { Button, Modal } from '@/components/ui';

interface DeleteConfirmModalProps {
  visible: boolean;
  title: string;
  message: string;
  onCancel: () => void;
  onConfirm: () => void;
  isDeleting?: boolean;
}

const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  visible,
  title,
  message,
  onCancel,
  onConfirm,
  isDeleting
}) => (
  // A short confirm — keep it a centered card on phones rather than a full-screen sheet.
  // Static backdrop while deleting so it can't be dismissed mid-request.
  <Modal
    show={visible}
    onHide={onCancel}
    mobileVariant="center"
    backdrop={isDeleting ? 'static' : true}
  >
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p className="tw-mb-0">{message}</p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onCancel} disabled={isDeleting}>
        Cancel
      </Button>
      <Button variant="danger" onClick={onConfirm} disabled={isDeleting}>
        {isDeleting ? 'Deleting...' : 'Delete'}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default DeleteConfirmModal;
